import { useMutation } from 'react-query';

import { uploadCardAssociatedDocument as mutationFn } from 'api/endPoints/uploadCardAssociatedDocument';

export const useMutationUploadDocumentFile = () => {
    return useMutation<any, QueryError, UploadDocumentPayload>({
        mutationFn,
    });
};

export type UploadDocumentPayload = File;
